"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const de_ui_1 = require("@delab-team/de-ui");
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const web_sdk_1 = require("@openproduct/web-sdk");
const ton_crypto_1 = require("ton-crypto");
const smlAddr_1 = require("../../helpers/smlAddr");
const svg_selector_1 = require("../../assets/svg-selector");
// import Example from '../../assets/img/example.png'
const connect_module_css_1 = __importDefault(require("./connect.module.css"));
const wallet_1 = require("../../logic/wallet");
const pinpad_1 = require("../pinpad");
const getClient_1 = require("../../utils/getClient");
const ConnectModal = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const wall = new wallet_1.CustomWallet((0, getClient_1.getDeLabClient)());
    const [position, setPosition] = react_1.default.useState(0);
    const [createAnimation, setCreateAnimation] = (0, react_1.useState)(undefined);
    const TgObj = sdk_1.default;
    const handleCloseModal = () => {
        TgObj.HapticFeedback.impactOccurred('medium');
        props.setShowConnectModal(false);
        TgObj.MainButton.hide();
        window.document.body.style.overflow = 'auto';
    };
    (0, react_1.useEffect)(() => {
        if (!props.connectModalProps) {
            handleCloseModal();
        }
    }, [props]);
    (0, react_1.useEffect)(() => {
        if (props.showConnectModal) {
            window.document.body.style.overflowY = 'hidden';
        }
        return () => {
            window.document.body.style.overflowY = 'visible';
            TgObj.MainButton.hide();
        };
    }, [props.showConnectModal]);
    const createResponse = react_1.default.useCallback(async () => {
        try {
            const loadData = await wall.loadHashSaveData();
            const httpProvider = new web_sdk_1.TonHttpProvider('https://mainnet.tonhubapi.com/jsonRPC');
            const WalletClass = web_sdk_1.ALL.v4R2;
            const walletContract = new WalletClass(httpProvider, {
                publicKey: (0, web_sdk_1.hexToBytes)(loadData.public),
                wc: 0
            });
            const walletStateInit = (await walletContract.createStateInit()).stateInit.toBase64();
            // console.log('walletStateInit', walletStateInit)
            console.log('props.psw.value', props.psw.value);
            const checkPsw = await wall.getPrivateKey(props.psw.value);
            if (typeof checkPsw === 'object') {
                // eslint-disable-next-line no-alert
                TgObj.MainButton.hideProgress();
                // TgObj.showAlert('Incorrect password')
                return;
            }
            const privateKey = wallet_1.CustomWallet.HashToKey(props.psw.value, loadData.iv, loadData.hash);
            if (!privateKey) {
                TgObj.MainButton.hideProgress();
                return;
            }
            const keyPair = await (0, ton_crypto_1.mnemonicToPrivateKey)(privateKey.split(' '));
            // maybe another secret key
            const secretKey = keyPair.secretKey;
            if (props.connectModalProps === undefined) {
                TgObj.MainButton.hideProgress();
                return;
            }
            if (!(await wall.isSaveWallet())) {
                TgObj.MainButton.hideProgress();
                return;
            }
            const { replyBuilder, requestPromise } = props.connectModalProps;
            const replyItems = replyBuilder.createReplyItems(loadData.address, secretKey, loadData.public, walletStateInit);
            requestPromise.resolve({
                address: loadData.address,
                replyItems,
                notificationsEnabled: false
            });
            TgObj.MainButton.hideProgress();
            handleCloseModal();
        }
        catch (error) {
            console.log(error);
        }
    }, [props.psw.value]);
    function showBtn() {
        if (position === 0) {
            TgObj.MainButton.show();
            TgObj.MainButton.enable();
            TgObj.MainButton.color = '#007AFF';
            TgObj.MainButton.text = t('common.next');
        }
        else if (position === 1) {
            TgObj.MainButton.show();
            // if (props.psw.value.length < 8 && props.psw.iserr !== 'valid') {
            //     TgObj.MainButton.text = t('common.password')
            //     TgObj.MainButton.color = '#9a9c9a'
            //     TgObj.MainButton.disable()
            // } else {
            //     TgObj.MainButton.enable()
            //     TgObj.MainButton.text = t('common.connect')
            //     TgObj.MainButton.color = '#007AFF'
            //     t('common.connect')
            // }
            TgObj.MainButton.text = t('common.connect');
            TgObj.MainButton.color = '#424B56';
            TgObj.MainButton.disable();
        }
    }
    function handleClick() {
        TgObj.HapticFeedback.impactOccurred('medium');
        if (position === 0) {
            setPosition(1);
        }
        // else if (position === 1) {
        //     createResponse()
        // }
    }
    const handleConnect = async () => {
        const checkPsw = await wall.getPrivateKey(props.psw.value);
        if (typeof checkPsw === 'object') {
            setCreateAnimation('failure');
            return;
        }
        setCreateAnimation('success');
        TgObj.MainButton.showProgress();
        await createResponse();
    };
    (0, react_1.useEffect)(() => {
        showBtn();
        TgObj.MainButton.onClick(() => handleClick());
        if (props.psw.value.length === 4) {
            handleConnect();
        }
        return () => {
            TgObj.MainButton.offClick(() => handleClick());
        };
    }, [position, props.psw.value]);
    return ((0, jsx_runtime_1.jsx)("div", { className: connect_module_css_1.default.wrapper, children: (0, jsx_runtime_1.jsxs)(de_ui_1.Modal, { isOpen: props.showConnectModal, onClose: handleCloseModal, className: connect_module_css_1.default.modal, isCloseButton: false, children: [(0, jsx_runtime_1.jsx)("div", { className: connect_module_css_1.default.modalTop, children: (0, jsx_runtime_1.jsx)(de_ui_1.Button, { className: connect_module_css_1.default.modalTopButton, onClick: handleCloseModal, tgStyles: { color: 'var(--tg-theme-link-color)' }, children: t('common.close') }) }), position === 0 && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(de_ui_1.Title, { variant: "h3", className: connect_module_css_1.default.modalInfoTitle, children: [t('common.connect-to'), " ", (0, jsx_runtime_1.jsx)("br", {}), " ", props?.connectModalProps?.manifest.name] }), (0, jsx_runtime_1.jsxs)("div", { className: connect_module_css_1.default.modalContent, children: [(0, jsx_runtime_1.jsxs)("div", { className: connect_module_css_1.default.modalConnect, children: [props?.addressUser && ((0, jsx_runtime_1.jsx)(de_ui_1.Div, { className: connect_module_css_1.default.modalUserAvatar, children: props.addressUser.slice(0, 2) })), (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "connect" }), (0, jsx_runtime_1.jsx)("img", { src: props.connectModalProps?.manifest.iconUrl, alt: "example" })] }), (0, jsx_runtime_1.jsx)("div", { className: connect_module_css_1.default.modalInfo, children: (0, jsx_runtime_1.jsxs)(de_ui_1.Text, { className: connect_module_css_1.default.modalInfoText, children: [props?.connectModalProps?.manifest.name, " ", t('common.is-want-to-connect') + ' ', t('common.to-your-wallet'), " ", (0, smlAddr_1.smlAddr)(props.addressUser)] }) })] })] })), position === 1 && (0, jsx_runtime_1.jsx)("div", { className: connect_module_css_1.default.modalContent, children: (0, jsx_runtime_1.jsx)(pinpad_1.PinPad, { title: t('pincod.enter'), onChange: e => props.psw.change(e), animationState: createAnimation, setAnimationState: setCreateAnimation }) }), (0, jsx_runtime_1.jsx)("div", { className: connect_module_css_1.default.background })] }) }));
};
exports.ConnectModal = ConnectModal;
